import styled, { css } from 'styled-components';
import { colors } from '../../variables/colors.js';
import { transitions } from '../../variables/transitions.js';

var Link = styled.a.withConfig({
  displayName: "style__Link",
  componentId: "sc-15hz78i-0"
})(["color:", ";cursor:pointer;overflow:visible;text-align:left;display:flex;align-items:center;"], colors.ocean);
var Icon = styled.span.withConfig({
  displayName: "style__Icon",
  componentId: "sc-15hz78i-1"
})(["fill:", ";margin-left:3px;", " ", " & svg{height:10px;width:10px;}"], colors.ocean, function (props) {
  return props.hasIconMargin && css(["margin:10px 10px 10px auto;padding-left:10px;"]);
}, function (props) {
  return props.hasLeadingIcon && css(["margin:0 3px 0 0;"]);
});
var LinkText = styled.span.withConfig({
  displayName: "style__LinkText",
  componentId: "sc-15hz78i-2"
})(["text-decoration:underline;color:", ";transition:border-color ", ",color ", ";", " ", " .no-touch &:hover{position:relative;text-decoration-line:underline;color:", ";fill:", ";}"], colors.ocean, transitions["default"], transitions["default"], function (props) {
  return props.hasIcon && css(["border-color:transparent;"]);
}, function (props) {
  return props.hasLeadingIcon && css(["order:2;"]);
}, colors.oceanL1, colors.oceanL1);
styled.ul.withConfig({
  displayName: "style__LinkList",
  componentId: "sc-15hz78i-3"
})(["li{line-height:20px;max-width:400px;}"]);

export { Icon, Link, LinkText };
//# sourceMappingURL=style.js.map
